<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fa-solid fa-newspaper"></i> Hírek</h1>
			</div>
			<div class="ms-auto">
				<button class="btn btn-success btn-rounded px-4 rounded-pill" v-b-modal.addNewsModal><i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új hír</button>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<panel title="Hírek">
					<Loading v-if="!news" title="Hírek betöltése"></Loading>
					<NoRecords v-else-if="news.length == 0" main_icon="fa-solid fa-newspaper" value="false" title="Nincsenek hírek" subtitle="adjon hozzá újat"></NoRecords>
					<vue-good-table v-else
						:columns="columns" 
						:rows="news" 
						:lineNumbers="true"
						:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
						:pagination-options="{
							enabled: true, 
							position: 'bottom',

						}"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<router-link :to="'/news/'+props.row.id+'/edit'" class="btn btn-warning btn-sm mx-1" title="szerkesztés"><i class="fa fa-edit"></i></router-link>
								<button @click="confirmDelete(props.row.id)" class="btn btn-danger btn-sm mx-1" title="delete"><i class="fa fa-trash"></i></button>
							</span>
							<span v-else>
								{{props.formattedRow[props.column.field]}}
							</span>
						</template>
					</vue-good-table>
				</panel>
			</div>
		</div>
		<b-modal id="addNewsModal" cancel-variant="default" @cancel="closeAddModal()" @ok="addNews" ok-title="Létrehozás" cancel-title="Mégse" :ok-disabled="loading" @shown="$refs.add_news_modal_name_input.focus()">
			<template slot="modal-header">
				<h4 class="modal-title">Új hír</h4>
				<a class="btn-close" @click="closeAddModal()"></a>
			</template>
			<form @submit.prevent="addNews()" ref="news_add_object_modal_form" v-if="loading == false">
				<div class="form-group">
					<label class="form-label">Cím:</label>
					<input ref="add_news_modal_name_input" class="form-control" type="text" v-model="news_add_object.name" required :class="{'is-invalid' : errors.name}">
					<div class="invalid-feedback d-block" v-if="errors.name">
							{{ errors.name[0] }}
					</div>
				</div>
				<div class="form-group">
					<label class="form-label">Leírás:</label>
					<textarea cols="30" rows="10" class="form-control" v-model="news_add_object.description" required :class="{'is-invalid' : errors.description}"></textarea>
					<div class="invalid-feedback d-block" v-if="errors.description">
							{{ errors.description[0] }}
					</div>
				</div>
				<button type="submit" class="d-none"></button>
			</form>
			<Loading v-if="loading == true" title="Létrehozás"></Loading>
		</b-modal>
	</div> 
</template>

<script>
	import News from "../../apis/News";
	import Confirmation from "../../apis/Confirmation"; 

	export default {
		data() {
			return {
				columns: [
					{
						label: 'Cím',
						field: 'name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Leírás',
						field: 'description',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Actions',
						field: 'actions',
						width: '15%',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end',
					}  
				],
				news: false,
				news_add_object: {},
				loading: false,
				roles: false,
				errors:[]
			}
		},
		created() {
			News.index()
			.then(response => {
				this.news = response.data;
			});
		},
		methods: {
			closeAddModal(){
				this.news_add_object = {};
				this.errors = [];
				this.$bvModal.hide('addNewsModal')
			},
			addNews(bvModalEvt){
				this.loading = true;
				if(bvModalEvt){ //ok gombra van csak event
					bvModalEvt.preventDefault();
				}
				this.errors = [];
				News.store(this.news_add_object)
				.then(response => {
					this.news.push(response.data);
					this.closeAddModal();
					this.$router.push({ name: 'EditNews', params: { id: response.data.id } });
				}).catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				}).finally(() => {
					this.loading = false;
				})
			},
			confirmDelete(id){
				Confirmation.swalDelete().then(response => {
					if(response.isConfirmed === true){
						this.deleteNews(id);
					}
				})
			},
			deleteNews(id) {
				News.delete(id)
					.then(() => {
						this.news.splice(this.news.map(n => n.id).indexOf(id),1);
					})
			},
		},
	}
</script>

<style>
	
</style>